/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 47,
  image: "default-changelog-v2.png",
  title: "Spheron Credits, Bonus Changes, New Marketplace Templates, Platform Improvements & Fixes",
  shortDescription: "We have released the Spheron Credits system , new Marketplace Templates, Private Docker Image Deployment, and a series of platform improvements and fixes.",
  description: "We have released the Spheron Credits system , new Marketplace Templates, Private Docker Image Deployment, and a series of platform improvements and fixes.",
  date: "Oct 9th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Spheron Credits
We are delighted to unveil the latest transformation to our platform - the introduction of the Spheron Credits system, designed to advance your payment experience and offer a more flexible alternative to the previous coupon system.

### Transition from Coupons to Credits

Recognizing the evolving needs of our community, we've transitioned from the coupon system to the more versatile Spheron Credits. These credits reflect our commitment to provide users with enhanced payment flexibility and streamlined transactional processes.

### Activate and Use Spheron Credits with Ease

After successfully applying the credit activation code, users will discover a new Spheron Credit payment method under their Billing Details. Designed with user convenience in mind, this feature provides an effortless way for users to conduct all payments across our platform using Spheron Credits.

### Universal Application across Organizations

One of the standout attributes of the Spheron Credits is their universal applicability. Single credit activation code can be deployed across multiple organizations on our platform. However, it's pivotal to remember that while credits can be spread across numerous organizations, they all draw from a singular, unified credit pool.

### Unified Payment Method for Spheron and Referral Credits

In scenarios where a user possesses both Spheron and Referral credits, our system simplifies the experience by representing them as one cohesive payment method. To prioritize and optimize the utilization of credits, referral credits will be exhausted before tapping into the Spheron Credits during any transaction.

Elevate your payment experience with the revolutionary Spheron Credits feature and enjoy seamless, flexible transactions across multiple organizations!

## New Marketplace Templates

### Minecraft

<div className="image-box-shadow">
  <img
    src="/changelog/2023-10-09/minecraft-banner.png"
    alt="minecraft"
    className="rounded-[12px]"
  />
</div>

- Minecraft is a renowned sandbox game crafted by Mojang Studios.
- Dive into diverse modes like survival, creative, and beyond.
- Celebrated for its innovative and exploratory gameplay.

[Deploy Minecraft Now](https://app.spheron.network/#/compute/marketplace?template=Minecraft)

### VS Code Server

<div className="image-box-shadow">
  <img
    src="/changelog/2023-10-09/vs-code-banner.png"
    alt="vs-code"
    className="rounded-[12px]"
  />
</div>

- Experience Visual Studio Code directly in your browser.
- Offers a unified web-based dev environment with all VS Code functionalities.
- Set up your coding station, reachable from any location.
- Whether you’re on a Chromebook, tablet, laptop, or a Windows/Mac workstation, enjoy seamless development for Linux.

[Deploy VS Code Server Now](https://app.spheron.network/#/compute/marketplace?template=VSCode%20Server)

## Private Docker Image Deployment

<div className="image-box-shadow">
  <img
    src="/changelog/2023-10-09/private-docker.png"
    alt="private-docker-form"
    className="rounded-[12px]"
  />
</div>

Users can now deploy images that are hosted on private container registries using Spheron.

- **Private Docker Images Support:** Spheron has introduced compatibility for Private Docker Images. These can be utilized with On-Demand Instances.
- **Broad Registry Integration:** The update embraces a range of the leading container registries. This encompasses platforms such as AWS, Github, Azure, and Google Container registries, among others.
- **Enhanced Security Approach:** Security remains paramount. To underline this, Spheron ensures that it doesn't retain any of your registry credentials. Instead, the image is relayed directly to our providers. This strategy is devised to bolster security during deployment, mitigating risks associated with storing sensitive user data.

## Bonus Changes

We are excited to introduce significant improvements to our bonus system, aiming to make them more accessible, manageable, and valuable to all our users. Here's a breakdown of the latest changes:

### Bonuses Now Have Their Own Activation and Expiration Date

- We've taken a big step forward by decoupling bonuses from subscription cycles. Bonuses will now have their unique activation and expiration dates, providing you with greater flexibility and control over their usage. Gone are the days when bonuses were tied to the subscription and would expire with it.
- To ensure simplicity and clarity, we have standardized the bonus duration to one month. This change makes it easier for you to keep track of when your bonuses will expire.

### Bonuses Now Available for Purchase on the Starter Plan

- We're thrilled to announce that you can now purchase bonuses on the Starter Plan! This exciting enhancement means that regardless of your subscription level, you can purchase bonuses and enjoy their benefits. We want to ensure all users can leverage our bonus features to their fullest potential.

### Support for Bonuses on the Storage Organization Side

- We understand the importance of bonuses in your workflow, and now we've extended support for bonuses to the Storage organization side. This feature will enable you to manage bonuses across your organization's storage resources efficiently.

## Platform Improvements & Fixes

- **Gateway Bandwidth Update:** The bandwidth consumption for Gateways has now been segregated from the CDN, enhancing clarity. This ensures distinct monitoring of your gateway data and CDN usage.
- **Invoice Issue Resolved:** The glitch causing duplicate PDF invoices during bonus purchases has been fixed.
- **Storage Status Code Adjustments:**
  - The Upload API now returns:
    - 413 status code for oversized payloads in Storage API.
    - 429 status code when the request count exceeds the set threshold in Storage API.
- **Bucket Search & Filter Improvements:**
  - Buckets can now be searched using partial IDs.
  - We've rectified the issue that neglected filters during bucket refresh.
- **Platform User Experience Enhancements:**
  - Label clarity has been ameliorated for better understanding.
  - Pagination has been optimized for fluid navigation.
  - Refresh mechanisms have been enhanced for improved reliability.
  - Multiple minor glitches have been addressed for a consistent and stable user experience.  
    `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
